// src/authProvider.js
import config from 'react-global-configuration';

var jwt = require('jsonwebtoken');

// in src/authProvider.js
const authProvider = {
    login: ({ username, password }) =>  {

        localStorage.removeItem('token');

        const apiUrl = config.get('app.api_url').replace(/\/$/, ''); // strip trailing slash
        const request = new Request(apiUrl + '/login', {
            method: 'POST',
            body: JSON.stringify({ email: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(token => {
                localStorage.setItem('token', token.token);
            });
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    checkAuth() {
        const token = localStorage.getItem('token');
        if (!token) return Promise.reject();

        const decodedToken = jwt.decode(token);
        if (!decodedToken) return Promise.reject();

        const dateNow = Math.floor(Date.now() / 1000);

        if (decodedToken.exp < dateNow) {
            return Promise.reject({ redirectTo: '/login' });
        }

        localStorage.setItem('permissions', decodedToken.roles);
        return Promise.resolve();
    },
    getPermissions: () => {
        const role = localStorage.getItem('permissions');
        return role ? Promise.resolve(role) : Promise.reject();
    },
    logout: () => {
        localStorage.removeItem('token');
        return Promise.resolve();
    },
    isAuthorised(roles, role) {

    let result = false;

    if(typeof roles !== 'undefined') {

        if (typeof (role) == 'object' && Array.isArray(role)) {

            let i;
            for (i = 0; i < role.length; i++) {

                if (roles.indexOf(role[i]) > -1) {
                    result = true;
                    break;
                }
            }
        } else {

            if (roles.indexOf(role) > -1) {
                result = true;
            }
        }
    }

    return result;
    }
};

export default authProvider;